// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"d152aec7","6407":"50db95f6","7945":"50db95f6"}[chunkId] + ".chunk.css";
};